'use client';

import {Global} from '@emotion/react';

import {SnackbarProvider} from 'Snackbar';

import {getFonts} from './fonts';

import type {PropsWithChildren} from 'common';
import type {SnackbarProviderProps} from 'Snackbar';

type ThemeProviderNextProps = {
  /** Путь к шрифтам X5 Sans
   *
   * также требуется скопировать из репозитория шрифты, и добавить в public/${fontsPath}
   */
  fontsPath?: string;
  snackbarProps?: SnackbarProviderProps;
} & PropsWithChildren;

/** Тема, совместима с Next.js (для не ssr используйте ThemeProvider)
 *
 * добавляет SnackbarProvider
 */
export const ThemeProviderNext: React.FC<ThemeProviderNextProps> = ({children, fontsPath, snackbarProps}) => (
  <SnackbarProvider {...snackbarProps}>
    {typeof fontsPath !== 'undefined' && <Global styles={getFonts(fontsPath)} />}
    {children}
  </SnackbarProvider>
);
